// SPEC-COLLECTION-FLAG-SYNC-01 (D-253): 集金確定時の集金フラグ整合(巡回 meter_readings.is_collected/flagged_at)の
//   ガード判定を DB に依存しない純関数へ切り出す。立てる/落とすの行選別そのものは services/collections.js の
//   syncCollectionFlags が Supabase のクエリフィルタ(eq/lte/gt/or)で行う(FIX_01: 判定を純関数とクエリで二重化しない)。

// 当該集金の collected_at がその店舗の最新 collected_at と「同等以上」か。
//   古い集金を後から入力したとき、新しいサイクルのフラグを落とさないためのガード(落とす側にのみ効かせる)。
//   店に他の集金が無い(max=null)なら当該が唯一=最新。値は同一カラム由来ゆえ辞書順比較で足りる。
export function isLatestCollection(thisCollectedAt, storeMaxCollectedAt) {
  if (!thisCollectedAt) return false
  if (!storeMaxCollectedAt) return true
  return String(thisCollectedAt) >= String(storeMaxCollectedAt)
}
